module.exports = "images/search_picto.26708f0b.png";